import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import DialogModal from '../../common/DialogModal';
import Typography from 'material-ui/Typography';
import Button from '../../Parts/Button';

const styles = () => ({
  text: {
    marginBottom: "40px",
    textAlign: "left",
  },

  textTitle: {
    marginBottom: "40px",
    textAlign: "left",
    fontWeight: 700
  },

  button: {
    background: "#F03A47",
    "&:hover::before": {
      backgroundColor: "#F03A47",
      opacity: 0.6,
    },
  },

  contentContainer: {
    padding: "50px 40px",
    margin: 0,
    display: "flex",
    flexDirection: "column",
    width: "450px",
    boxSizing: "border-box",
    background: "#FFFFFF",
  },

  buttonContainer: {
    display: 'inline-flex',
    width: '100%',
    justifyContent: 'space-evenly',
    marginTop: '40px',
  }
});

class ConfirmFollowCallOrderDialog extends React.Component {
  handleClick = () => {
    this.props.toggleDialog();
    this.props.action();
  };

  render() {
    const { classes } = this.props;

    return (
      <DialogModal
        open={this.props.isOpen}
        onClose={this.props.toggleDialog}
        message={this.props.message}
        aria-labelledby="pop-up-window"
        maxWidth={false}
        classes={{
          contentContainer: classes.contentContainer
        }}
      >
        <Typography variant="subheading" className={classes.textTitle}>
          注文にフォローコール依頼済みの宛先が含まれています
        </Typography>
        <Typography variant="subheading" className={classes.text}>
          宛先を間違えていませんか？<br />
          あなたかチームの誰かが既にコール依頼をしています。<br />
          このまま注文を進めてもよいかご確認ください。<br /><br />
          宛先：{this.props.message}
        </Typography>
        <div className={classes.buttonContainer}>
          <Button
            handleClickButton={this.props.toggleDialog}
            text="キャンセル"
            type="ghost"
          ></Button>

          <Button
            handleClickButton={this.handleClick}
            text='注文を続行する'
          ></Button>
        </div>
      </DialogModal>
    );
  }
}

ConfirmFollowCallOrderDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  message: PropTypes.string,
  action: PropTypes.func.isRequired,
};

export default withStyles(styles)(ConfirmFollowCallOrderDialog);



// WEBPACK FOOTER //
// ./src/components/AddressBook/dialogs/ConfirmFollowCallOrderDialog.jsx